import { render, staticRenderFns } from "./AvDivider.vue?vue&type=template&id=41669edc"
import script from "./AvDivider.vue?vue&type=script&lang=ts"
export * from "./AvDivider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports